/**
 * Cookie-domain helpers shared by the identity and ad-attribution stores.
 * Both persist to a root-domain cookie so their value survives cross-subdomain
 * navigation (e.g. `querobolsa.com.br` → `checkout.querobolsa.com.br`).
 */

/**
 * Reduce a hostname to its registrable root domain, honoring the compound
 * `com.br` TLD used across the Quero properties. Falls back to the last two
 * labels for everything else.
 */
export function extractRootDomain(hostname: string): string {
  const parts = hostname.split('.')

  if (parts.length <= 2) {
    return hostname
  }

  const compoundTlds = ['com.br']

  if (parts.length >= 3) {
    const lastTwo = parts.slice(-2).join('.')
    if (compoundTlds.includes(lastTwo)) {
      return parts.slice(-3).join('.')
    }
  }

  return parts.slice(-2).join('.')
}

/** Leading-dot root-domain string for `Cookie.set({ domain })`. */
export function getCookieDomain(): string {
  return `.${extractRootDomain(window.location.hostname)}`
}

/** Whether the page is served over HTTPS (drives the cookie `secure` flag). */
export function isSecureContext(): boolean {
  return window.location.protocol === 'https:'
}
